
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category_leaders_methodology",
      function () {
        return require("private-next-pages/category_leaders_methodology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category_leaders_methodology"])
      });
    }
  